import { render, staticRenderFns } from "./pension-planningHome.vue?vue&type=template&id=3523d3e8&scoped=true&"
import script from "./pension-planningHome.vue?vue&type=script&lang=js&"
export * from "./pension-planningHome.vue?vue&type=script&lang=js&"
import style0 from "./pension-planningHome.vue?vue&type=style&index=0&id=3523d3e8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3523d3e8",
  null
  
)

export default component.exports